<template>
  <SmTooltip>
    <template #content>
      <div style="display: grid; grid-template-columns: auto auto; gap: 0 10px">
        <!-- Exceeded Quota -->
        <template v-if="quotaExceeded">
          <p class="col-span-2 pb-2 font-bold">
            {{ i18n.t('exceededQuota') }}
          </p>
          <p>{{ i18n.t('quota') }}:</p>
          <p>
            {{ props.quotaInformation?.quota }}
          </p>
          <p>{{ i18n.t('used') }}:</p>
          <p>
            {{ props.quotaInformation?.used }}
          </p>
        </template>

        <!-- Quotainfo -->
        <template v-else>
          <span>{{ i18n.t('quota') }}:</span>
          <span>{{ props.quotaInformation?.quota }}</span>
          <span>{{ i18n.t('used') }}:</span>
          <span>{{ props.quotaInformation?.used }}</span>
          <span>{{ i18n.t('remaining') }}:</span>
          <span>{{ props.quotaInformation?.available }}</span>
        </template>
      </div>
    </template>

    <SmProgressBar
      :value="props.quotaInformation?.used"
      :max="props.quotaInformation?.quota"
      :color="quotaExceeded ? 'var(--sm-red)' : undefined" />
  </SmTooltip>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'
  import { QuotaInformation_Input } from '@/client'

  const i18n = useI18n()

  const props = defineProps<{
    quotaInformation: QuotaInformation_Input
  }>()

  const quotaExceeded = computed(() => {
    return props.quotaInformation?.available < 0
  })
</script>
